// extracted by mini-css-extract-plugin
export default {"header":"GuidelinesComponent_header__l6EKY","subscription":"GuidelinesComponent_subscription__QRQub"};